import { useBroadcastData } from "../../BroadcastDataContext";

export const useBroadcastPreviewContent = () => {
  const { data, isLoading } = useBroadcastData();

  const {
    email_content_type,
    email_content,
    visual_email_builder_content_html,
  } = data?.broadcast_content ?? {
    email_content_type: "",
    email_content: null,
    visual_email_builder_content: null,
    visual_email_builder_content_html: null,
  };

  return {
    emailContentType: email_content_type,
    emailContent: email_content,
    visualEmailBuilderContentHtml: visual_email_builder_content_html,
    emailTheme: data?.email_theme,
    isLoading,
  };
};
